import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetaAdVisit, trackPageReached, trackPageView } from '../utils/metaPixel';
import { trackRoute } from '../utils/visitTracking';
import { getPageName } from '../utils/pageNames';

/**
 * Fires analytics on every route change, to both destinations:
 *
 *   Meta pixel      — powers ad optimisation and Events Manager reporting
 *   Our own backend — powers the Immersia admin dashboard, and counts the
 *                     visitors ad blockers hide from the pixel
 *
 * Required for a SPA: the pixel only auto-fires PageView on a full document
 * load, so client-side navigation would otherwise be invisible and the whole
 * funnel would collapse into a single landing hit.
 *
 * Renders nothing — mount it once inside the Router.
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const pageName = getPageName(location.pathname);

    trackPageView();
    trackPageReached(pageName, location.pathname);
    trackMetaAdVisit(pageName, location.pathname);

    trackRoute(location.pathname);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
